module.exports = __webpack_public_path__ + "img/finished.e6854ce7.png";